import { render, staticRenderFns } from "./page007.vue?vue&type=template&id=2a1869ce&scoped=true&"
import script from "./page007.vue?vue&type=script&lang=js&"
export * from "./page007.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1869ce",
  null
  
)

export default component.exports